module.exports = "/_next/static/images/logo-light.3e3e950582be21c08736e05bfa2ea9eb.svg";